export default __webpack_public_path__ + "static/media/impact-gif.d44b5c3a.gif";